import { makeSvgImage } from '../../../../components/SvgImage/index.ts';

export const Boat = makeSvgImage(
  <svg xmlns="http://www.w3.org/2000/svg" width="133" height="51" fill="none">
    <path fill="#FB8431" d="M11.48 23.02h118.15l-3.17 10.82H15.7l-4.22-10.82Z" />
    <path
      fill="#D66313"
      d="M12.86 24.14s21.21 4.82 44.5 6.14c23.28 1.32 73.71-6.14 73.71-6.14s-1.09 10.02-5.6 13.99c-10.69 9.4-29.1 10.16-29.1 10.16s-15.36.96-25.23.95c-9.75 0-24.96-.95-24.96-.95s-21.3-1.81-28.24-11.48c-3.1-4.33-5.08-12.67-5.08-12.67Z"
    />
    <path
      stroke="#B64C01"
      strokeWidth="1.32"
      d="M11.8 24.14s33.88 6.37 57.1 6.9c23.22.52 61.12-6.9 61.12-6.9"
    />
    <path
      stroke="#B64C01"
      strokeOpacity=".6"
      strokeWidth=".66"
      d="M13.26 28.53s23.12 7.19 46.34 7.72c23.22.53 70.42-7.88 70.42-7.88"
    />
    <g filter="url(#a)">
      <path
        fill="#C35508"
        d="M97.47 23.52c0 .95-8.24 2.56-20.85 3.2-10.56.53-24.72.27-34.63-.53-3.42-.28-12.67-.4-12.67-2.15 0-1.74 16.58-1.02 36.38-1.02 19.8 0 31.77-1.25 31.77.5Z"
      />
    </g>
    <path
      stroke="#B64C01"
      strokeOpacity=".6"
      strokeWidth=".66"
      d="M14.88 34.14S36.38 40.47 59.6 41c23.22.53 67.58-7.75 67.58-7.75"
    />
    <path
      stroke="#B64C01"
      strokeOpacity=".6"
      strokeWidth=".66"
      d="M19.6 39.55s16.78 6.2 40 6.73c23.22.52 64.58-6.93 64.58-6.93"
    />
    <path
      stroke="#992A2A"
      strokeWidth="2.64"
      d="M11.64 22.9s2.14 9.58 5.25 13.9c6.94 9.68 28.23 11.49 28.23 11.49s15.21.95 24.97.95c9.86 0 25.23-.95 25.23-.95s22.52-.27 29.65-9.96c3.9-5.3 5.74-15.6 5.74-15.6"
    />
    <path
      fill="#B64C01"
      fillRule="evenodd"
      d="m97.83 24.01-21.1 4.42-6.74-11.28 22.43-3.76 5.41 10.62Zm-23.36-3.54c-.3-.73 0-1.57.7-1.92.88-.44 2.07-.97 3.03-1.21 1.24-.3 3.39-.18 4.55-.08.5.04.94.34 1.19.77l3.28 5.77c.1.16 0 .36-.18.4l-10.1 1.82a.26.26 0 0 1-.29-.16l-2.18-5.39Zm12-4.02a1.56 1.56 0 0 0-.73 2.01l2.31 5.4c.06.13.19.2.31.16l6.84-1.81a.26.26 0 0 0 .17-.38l-3.1-5.88a1.4 1.4 0 0 0-.84-.7 4.24 4.24 0 0 0-2.27-.02c-.67.24-1.8.78-2.69 1.22Zm-9.75 11.98L41.56 26.1s.04-4.17 1.36-6.33c.92-1.5 3.18-3.21 3.18-3.21l23.89.6 6.73 11.27ZM55.46 18.2a1.58 1.58 0 0 0-1.63 1.58v5.81l9.76.4V20c0-.85-.68-1.55-1.53-1.58l-6.6-.22Zm-11.29 2.76a3.7 3.7 0 0 1 3.8-3.15l3.29.14c.84.03 1.51.73 1.51 1.58v6l-9.17-.73.57-3.84Zm24.25-2.16a3.7 3.7 0 0 1 3.46 2.4l2.05 5.42-9.24-.3v-5.94c0-.87.71-1.58 1.59-1.58h2.14Z"
      clipRule="evenodd"
    />
    <path
      fill="#D1ECFE"
      fillOpacity=".6"
      d="M74.47 20.5c-.3-.73 0-1.58.7-1.93.88-.43 2.07-.97 3.03-1.2 1.24-.3 3.39-.18 4.55-.08.5.04.94.33 1.19.77l3.28 5.77c.1.16 0 .36-.18.39l-10.1 1.82a.26.26 0 0 1-.29-.16l-2.18-5.38Zm11.27-2.01a1.56 1.56 0 0 1 .73-2.02c.9-.44 2.02-.98 2.69-1.21a4.13 4.13 0 0 1 2.27.02c.37.1.66.36.84.7l3.1 5.87c.08.15 0 .34-.17.38l-6.84 1.81a.26.26 0 0 1-.3-.15l-2.32-5.4ZM53.83 19.8c0-.9.74-1.6 1.63-1.58l6.6.22c.85.03 1.53.73 1.53 1.59v5.99l-9.76-.4V19.8Zm-9.66 1.19a3.7 3.7 0 0 1 3.8-3.15l3.29.13c.84.04 1.51.73 1.51 1.58v6l-9.16-.72.56-3.84Zm27.71.23a3.7 3.7 0 0 0-3.45-2.4h-2.15c-.88 0-1.59.71-1.59 1.59v5.94l9.24.3-2.05-5.43Z"
    />
    <path
      fill="#992A2A"
      d="m127.15 23.02 4.85-1.25v1.25h-4.86Zm-112.01 0-4.85-1.25.07 1.42 3.7-.17h1.08Z"
    />
    <path fill="#B64C01" d="M22.96 6h.66v18.21h-.66z" />
    <ellipse cx="23.25" cy="24.24" fill="#B64C01" rx="1.48" ry=".36" />
    <path
      fill="#D0453E"
      d="M3.86 1.82S7.34 4 10.22 4.83c3.06.9 4.93-1.44 8.02-.75 2.96.65 4.87 2.3 4.87 2.3l-.03 11.74s-2.62-3.66-5.28-4c-2.51-.3-3.3 2.17-5.83 2.33-2.01.12-3.36-.83-5.18-.99-.94-.08-1.93 1-1.93 1s-1.61-2.11-2.01-3.58c-.7-2.56 1.64-3.57 1.7-6.23.04-1.9-.69-4.83-.69-4.83Z"
    />
    <mask
      id="b"
      width="22"
      height="18"
      x="2"
      y="1"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
    >
      <path
        fill="#D0453E"
        d="M3.86 1.82S7.34 4 10.22 4.83c3.06.9 4.93-1.44 8.02-.75 2.96.65 4.87 2.3 4.87 2.3l-.03 11.74s-2.62-3.66-5.28-4c-2.51-.3-3.3 2.17-5.83 2.33-2.01.12-3.36-.83-5.18-.99-.94-.08-1.93 1-1.93 1s-1.61-2.11-2.01-3.58c-.7-2.56 1.64-3.57 1.7-6.23.04-1.9-.69-4.83-.69-4.83Z"
      />
    </mask>
    <g mask="url(#b)">
      <path
        stroke="#fff"
        strokeWidth="2.82"
        d="M3.53 7.84s4.02 1.95 6.3 2.2c2.53.3 3.83.07 6.28-.71a5.17 5.17 0 0 1 3.94.17c1.17.43 4.12 2.19 4.12 2.19"
      />
      <path
        stroke="#415798"
        strokeWidth="1.41"
        d="M3.89 8.05s3.66 1.74 5.94 2c2.53.29 3.83.06 6.27-.72a5.17 5.17 0 0 1 3.95.17c1.17.43 3.66 2.05 3.66 2.05"
      />
      <path fill="#415798" stroke="#fff" strokeWidth=".7" d="m15.38 3.04 2.1-.05.3 11.63-2.1.06z" />
    </g>
    <defs>
      <filter
        id="a"
        width="68.14"
        height="4.67"
        x="29.32"
        y="22.59"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy=".26" />
        <feGaussianBlur stdDeviation=".66" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="shape" result="effect1_innerShadow_7879_25486" />
      </filter>
    </defs>
  </svg>,
);
